export enum Steps {
  WHERE_YOU_ARE_TODAY = "Where you are today",
  WHAT_KIND_OF_JOURNEY = "What kind of Journey",
  WHAT_KIND_OF_JOURNEY_IVF_DECISION = "What kind of journey IVF decision",
  WHERE_ARE_YOU_IN_JOURNEY = "Where are you in journey",
  WHERE_ARE_YOU_IN_JOURNEY_DECISION = "Where are you in journey decision",
  WHERE_ARE_YOU_IN_JOURNEY_IVF_DECISION = "Where are you in journey IVF decision",
  NAME_OF_AGENCY = "Name of agency",
  NAME_OF_CLINIC_AGENCY_ATTORNEY = "Name of clinic agency attorney",
  NAME_OF_CLINIC = "Name of clinic",
  MOST_HELPFUL = "What would be most helpful",
  US_MOST_HELPFUL = "US or non US",
  MOST_HELPFUL_DECISION = "What would be most helpful decision",
  WHAT_KIND_OF_JOURNEY_SHARE_BACKGROUND_DECISION = "What kind of journey share background decision",
  PERSON_OF_COLOR_SHARE_BACKGROUND = "Person of color share background",
  WHAT_KIND_OF_JOURNEY_FINAL_DECISION = "What kind of journey final decision",
  IVF_INFORMATION = "IVF information",
  ADOPTION_PATHWAY = "Adoption pathway",
  GESTATIONAL_CARRIER_IN_MIND = "Gestational carrier in mind",
  GESTATIONAL_CARRIER_DELIVERY = "Gestational carrier delivery",
  DO_ANY_APPLY = "Do any apply",
  WHAT_KIND_OF_JOURNEY_PRESERVATION_DECISION = "What kind of journey preservation decision",
  PRESERVATION = "Preservation",
  ANYTHING_ELSE = "Anything else",
  PROCESS_CREATE_CARROT_PLAN = "Process create Carrot Plan",
  ITS_A_MATCH_URGENT_PROVIDER_PLACEMENT = "It's a match urgent provider placement",
  ITS_A_MATCH_NON_URGENT = "It's a match non urgent",
  PROCESS_ITS_A_MATCH = "Process It's A Match",
  MESSAGE_WONDERFUL = "Message wonderful",
  EXPERT_CHAT_WONDERFUL = "Expert chat wonderful",
  ITS_A_MATCH_DECISION = "It's a match decision step",
  GESTATIONAL_CARRIER_IS_US_DECISION = "US or non US for Gestational carrier",
  ADOPTION_IS_US_DECISION = "US or non US for Adoption",
  LGBTQ_PLUS_IS_US_DECISION = "US or non US for LGBTQ Plus",
  FERTILITY_PRESERVATION_IS_US_DECISION = "US or non US for Fertility preservation",
  ASSISTED_REPRODUCTION_IS_US_DECISION = "US or non US for Assisted reproduction",
  ATTEMPTING_TO_GET_PREGNANT_IS_US_DECISION = "US or non US for Attempting to get pregnant",
  CURRENTLY_PREGNANT_IS_US_DECISION = "US or non US for Currently pregnant",
  SET_CARE_NAVIGATION_FIRST_RESPONDER = "Set Care Navigation first responder",
  SET_ADOPTION_FIRST_RESPONDER = "Set adoption first responder",
  SET_GESTATIONAL_CARRIER_FIRST_RESPONDER = "Set gestational carrier first responder",
  SET_FERTILITY_FIRST_RESPONDER = "Set fertility first responder",
  SET_LGBTQ_FAMILY_FIRST_RESPONDER = "Set LGBTQ+ first responder",
  SET_PREGNANCY_FIRST_RESPONDER = "Set Pregnancy first responder",
  CARE_NAVIGATION_DECISION = "Care Navigation Decision",
  // medical question steps
  SHOW_MEDICAL_QUESTIONS_DECISION = "Show Medical Questions Decision Step",
  WELCOME = "Medical Questions Welcome",
  BIOLOGICAL_CHILDREN = "biologicalChildren",
  MEDICAL_HISTORY = "medicalHistory",
  MEDICAL_CONDITIONS = "conditions",
  FAMILY_MEDICAL_CONDITIONS = "familyConditions",
  CURRENTLY_TAKING = "currentlyTaking",
  SMOKE_DRINK = "smokeDrink",
  CURRENTLY_EXPERIENCING = "experiencingSymptoms",
  HEIGHT_WEIGHT = "heightWeight",
  WHAT_KIND_OF_JOURNEY_AFAB_DECISION = "What kind of journey AFAB decision",
  PAST_FERTILITY_TREATMENT = "pregnancyPastFertilityTreatment",
  PREGNANCY_MET_WITH_OBGYN = "pregnancyMetWithObgyn",
  CYCLES_ARE_REGULAR = "cyclesAreRegular",
  CYCLE_DETAILS = "cycleDetails",
  PERIODS_PAINFUL = "periodsPainful",
  PERIODS_PAINFUL_DETAILS = "periodsPainfulDetails",
  PREGNANT_PREVIOUSLY = "pregnantPreviously",
  PREGNANT_PREVIOUSLY_DETAILS = "pregnantPreviouslyDetails",
  PELVIC_SURGERY = "pelvicSurgeryDetails",
  AMAB_OR_AFAB_DECISION = "AMAB or AFAB"
  // end medical question steps
}
